export function eventRegTierLabel(tier) {
  if (tier === "juniors") return "Juniors (4\u20138 years)";
  if (tier === "intermediates") return "Intermediates (9\u201315 years)";
  if (tier === "seniors") return "Seniors (16+) & family";
  return "Competitions";
}

export function eventRegTierTrophyClass(tier) {
  if (tier === "juniors") return "text-bul-magenta";
  if (tier === "intermediates") return "text-bul-cyan";
  return "text-bul-amber";
}

export function eventRegTierChipClass(tier) {
  if (tier === "juniors")
    return "text-bul-magenta bg-bul-magenta/10 border-bul-magenta/40";
  if (tier === "intermediates")
    return "text-bul-cyan bg-bul-cyan/10 border-bul-cyan/40";
  return "text-bul-amber bg-bul-amber/10 border-bul-amber/40";
}

export function eventRegTierBlurb(tier) {
  if (tier === "juniors") {
    return "Born between 2 Jul 2017 and 1 Jul 2022 (inclusive). Pick from the three Junior competitions below.";
  }
  if (tier === "intermediates") {
    return "Born between 2 Jul 2010 and 1 Jul 2017 (inclusive). Pick from the eight Intermediate competitions below.";
  }
  return "Born on or before 1 Jul 2010. Pick from the Senior competitions and the family game show below.";
}

export function bulandiEventsSectionWrapClass(_highlight) {
  return "scroll-mt-24";
}
